function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSp500(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 219.64,222.58 V 331.64",
    style: {
      fill: "none",
      stroke: "#dedede",
      strokeWidth: 0.53,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path164"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 219.64,222.58 H 328.7",
    style: {
      fill: "none",
      stroke: "#dedede",
      strokeWidth: 0.53,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 219.64,222.58 V 113.53",
    style: {
      fill: "none",
      stroke: "#dedede",
      strokeWidth: 0.53,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path168"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 219.64,222.58 H 110.59",
    style: {
      fill: "none",
      stroke: "#dedede",
      strokeWidth: 0.53,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path170"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 219.64,222.58 V 331.64",
    style: {
      fill: "none",
      stroke: "#dedede",
      strokeWidth: 0.53,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path172"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 219.64,222.58 V 331.64",
    style: {
      fill: "none",
      stroke: "#dedede",
      strokeWidth: 0.27,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path174"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 219.64,222.58 77.12,77.12",
    style: {
      fill: "none",
      stroke: "#dedede",
      strokeWidth: 0.27,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path176"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 219.64,222.58 H 328.7",
    style: {
      fill: "none",
      stroke: "#dedede",
      strokeWidth: 0.27,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path178"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 219.64,222.58 77.12,-77.11",
    style: {
      fill: "none",
      stroke: "#dedede",
      strokeWidth: 0.27,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path180"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 219.64,222.58 V 113.53",
    style: {
      fill: "none",
      stroke: "#dedede",
      strokeWidth: 0.27,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path182"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 219.64,222.58 142.53,145.47",
    style: {
      fill: "none",
      stroke: "#dedede",
      strokeWidth: 0.27,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path184"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 219.64,222.58 H 110.59",
    style: {
      fill: "none",
      stroke: "#dedede",
      strokeWidth: 0.27,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path186"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 219.64,222.58 142.53,299.7",
    style: {
      fill: "none",
      stroke: "#dedede",
      strokeWidth: 0.27,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path188"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 219.64,222.58 V 331.64",
    style: {
      fill: "none",
      stroke: "#dedede",
      strokeWidth: 0.27,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path190"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 219.64,271.05 3.08,-0.1 3.06,-0.29 3.04,-0.48 3,-0.68 2.95,-0.87 2.89,-1.05 2.81,-1.23 2.74,-1.41 2.64,-1.58 2.53,-1.75 2.42,-1.9 2.29,-2.05 2.16,-2.19 2.01,-2.32 1.86,-2.45 1.71,-2.56 1.54,-2.67 1.36,-2.75 1.19,-2.84 1.01,-2.91 0.82,-2.96 0.63,-3.01 0.43,-3.04 0.25,-3.07 0.05,-3.08 -0.15,-3.07 -0.34,-3.05 -0.54,-3.03 -0.72,-2.99 -0.91,-2.94 -1.1,-2.87 -1.28,-2.8 -1.45,-2.71 -1.62,-2.62 -1.79,-2.5 -1.94,-2.39 -2.08,-2.26 -2.23,-2.12 -2.36,-1.98 -2.47,-1.82 -2.59,-1.66 -2.69,-1.5 -2.77,-1.32 -2.86,-1.14 -2.92,-0.96 -2.98,-0.78 -3.02,-0.58 -3.05,-0.39 -3.07,-0.19 h -3.08 l -3.06,0.19 -3.06,0.39 -3.02,0.58 -2.97,0.78 -2.93,0.96 -2.85,1.14 -2.78,1.32 -2.69,1.5 -2.58,1.66 -2.48,1.82 -2.36,1.98 -2.22,2.12 -2.09,2.26 -1.94,2.39 -1.78,2.5 -1.62,2.62 -1.46,2.71 -1.27,2.8 -1.1,2.87 -0.91,2.94 -0.73,2.99 -0.53,3.03 -0.34,3.05 -0.15,3.07 0.05,3.08 0.24,3.07 0.44,3.04 0.63,3.01 0.82,2.96 1,2.91 1.19,2.84 1.37,2.75 1.54,2.67 1.7,2.56 1.86,2.45 2.02,2.32 2.15,2.19 2.3,2.05 2.41,1.9 2.54,1.75 2.64,1.58 2.73,1.41 2.82,1.23 2.89,1.05 2.95,0.87 3,0.68 3.04,0.48 3.06,0.29 3.07,0.1",
    style: {
      fill: "none",
      stroke: "#dedede",
      strokeWidth: 0.53,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path192"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 219.64,331.64 6.92,-0.22 6.89,-0.66 6.83,-1.09 6.75,-1.53 6.64,-1.95 6.5,-2.36 6.34,-2.78 6.16,-3.17 5.93,-3.55 5.7,-3.93 5.44,-4.27 5.16,-4.62 4.85,-4.93 4.54,-5.23 4.19,-5.51 3.83,-5.76 3.46,-5.99 3.07,-6.2 2.68,-6.39 2.26,-6.54 1.84,-6.67 1.42,-6.77 0.99,-6.85 0.55,-6.9 0.11,-6.92 -0.33,-6.91 -0.77,-6.88 -1.2,-6.81 -1.63,-6.73 -2.06,-6.61 -2.47,-6.46 -2.87,-6.3 -3.27,-6.1 -3.65,-5.88 -4.01,-5.63 -4.37,-5.37 -4.69,-5.09 -5.01,-4.77 -5.3,-4.45 -5.58,-4.1 -5.82,-3.75 -6.05,-3.36 -6.24,-2.97 -6.43,-2.58 -6.57,-2.16 -6.7,-1.73 -6.8,-1.31 -6.86,-0.88 -6.91,-0.44 h -6.92 l -6.9,0.44 -6.87,0.88 -6.79,1.31 -6.7,1.73 -6.58,2.16 -6.42,2.58 -6.25,2.97 -6.05,3.36 -5.82,3.75 -5.57,4.1 -5.3,4.45 -5.01,4.77 -4.7,5.09 -4.36,5.37 -4.01,5.63 -3.65,5.88 -3.27,6.1 -2.88,6.3 -2.47,6.46 -2.05,6.61 -1.63,6.73 -1.2,6.81 -0.77,6.88 -0.33,6.91 0.11,6.92 0.55,6.9 0.98,6.85 1.42,6.77 1.84,6.67 2.27,6.54 2.67,6.39 3.07,6.2 3.46,5.99 3.84,5.76 4.19,5.51 4.53,5.23 4.85,4.93 5.16,4.62 5.44,4.27 5.7,3.93 5.94,3.55 6.15,3.17 6.34,2.78 6.5,2.36 6.64,1.95 6.75,1.53 6.84,1.09 6.89,0.66 6.91,0.22",
    style: {
      fill: "none",
      stroke: "#dedede",
      strokeWidth: 0.53,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path194"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSp500);
export default __webpack_public_path__ + "static/media/sp500.a44240d7.svg";
export { ForwardRef as ReactComponent };